<template>
  <div class="v-dropzone" :style="style">
    <div class="v-dropzone__textnode">
      <slot name="instructions">Drop file here...</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dropzone',
  created () {
    // Add drag and drop event listeners
    this.events.forEach(event => {
      window.addEventListener(event, this[event])
    })
  },
  destroyed () {
    // Remove drag and drop event listeners
    this.events.forEach(event => {
      window.removeEventListener(event, this[event])
    })
  },
  props: {
    /**
     * Disable dropzone function
     */
    errorChecker: {
      type: Function,
      required: false
    }
  },
  data () {
    return {
      /**
       * Show dropzone placeholder
       */
      placeholder: false,
      /**
       * List of dropzone events
       */
      events: ['dragenter', 'dragleave', 'dragover', 'drop']
    }
  },
  computed: {
    /**
     * Dropzone style
     */
    style () {
      return this.placeholder
        ? {}
        : {
          visibility: 'hidden',
          opacity: 0
        }
    }
  },
  methods: {
    /**
     * dragenter listener
     */
    dragenter (event) {
      if (this.callErrorCheckerIfExists(event)) {
        return
      }
      this.$set(this, 'placeholder', true)
    },
    /**
     * dragleave listener
     */
    dragleave (event) {
      event.preventDefault()
      if (this.callErrorCheckerIfExists(event)) {
        return
      }
      this.$set(this, 'placeholder', false)
    },
    /**
     * dragover listener
     */
    dragover (event) {
      event.preventDefault()
      if (this.callErrorCheckerIfExists(event)) {
        return
      }
      this.$set(this, 'placeholder', true)
    },
    /**
     * drop listener
     */
    drop (event) {
      event.preventDefault()
      if (this.callErrorCheckerIfExists(event)) {
        return
      }
      this.$set(this, 'placeholder', false)
      const { files } = event.dataTransfer
      this.$emit('dropped', files)
    },
    /**
     * Call error checker function if provided to the component
     */
    callErrorCheckerIfExists (event) {
      return (typeof this.errorChecker === 'function')
        ? this.errorChecker(event)
        : false
    }
  }
}
</script>

<style lang="sass">
.v-dropzone
  position: fixed
  top: 0
  left: 0
  z-index: 99999999999
  width: 100%
  height: 100%
  background-color: rgba(0, 0, 0, .5)
  transition: visibility 175ms, opacity 175ms
  display: table
  text-shadow: 1px 1px 1px #000
  color: #fff
  background: rgba(0, 0, 0, .45)
  font-size: 42px
  font-weight: bold

  .v-dropzone__textnode
    display: table-cell
    text-align: center
    vertical-align: middle
    transition: font-size 175ms
</style>
